import type { ReactElement } from 'react';
import { ShieldAlert } from 'lucide-react';
import { Button } from '../components/ui';
import { useAuth } from './useAuth';

const DEFAULT_MESSAGE = 'Esta conta não tem acesso ao painel web.';

export interface AuthErrorScreenProps {
  /** Override the default "no access" copy (e.g. "store not found"). */
  message?: string;
}

/**
 * Full-screen dead-end for sessions that authenticated but lack web-panel
 * access (RF-001 / DP-014: a customer/courier token). Deliberately terse —
 * it doesn't reveal which roles exist — and offers only a logout.
 */
export function AuthErrorScreen({ message = DEFAULT_MESSAGE }: AuthErrorScreenProps): ReactElement {
  const logout = useAuth((state) => state.logout);
  return (
    <main className="min-h-screen flex items-center justify-center bg-bg p-4">
      <div className="w-full max-w-md rounded-card border border-border bg-bg-card p-8 text-center shadow-2xl">
        <ShieldAlert size={40} className="mx-auto text-warning" aria-hidden />
        <p className="mt-4 text-base text-white">{message}</p>
        <Button variant="secondary" className="mt-6" onClick={() => logout()}>
          Sair
        </Button>
      </div>
    </main>
  );
}
